module.exports = __webpack_public_path__ + "static/media/1013025.d16a44de.jpg";